import React, { useCallback } from 'react'
import { GuidedTour } from '@e3dc-react/shell/Elements/GuidedTour'
import { useTypedSelector } from 'src/State/RootReducer'
import { setEMobilityTourRunning } from '../shared/components/EMobilityTourBanner'
import { useEMobilityTourSteps } from './use-e-mobility-tour-steps'

export const EMobilityGuidedTour: React.FC = () => {
  const eMobilityTourRunning = useTypedSelector(state => state.eMobility.tour.isRunning)
  const emobilityTourGuideSteps = useEMobilityTourSteps()

  const handleTourFinish = useCallback(() => {
    setEMobilityTourRunning(false)
  }, [])

  return <GuidedTour steps={emobilityTourGuideSteps} run={eMobilityTourRunning} onTourComplete={handleTourFinish} />
}
